import { Link } from "@tanstack/react-router";
import { BUSINESS } from "@/lib/site-data";
import { CallNowButton } from "@/components/CallNowButton";
import { ThemeToggle } from "@/components/ThemeToggle";

type NavLink = { to: string; label: string; exact?: boolean };
const navLinks: NavLink[] = [
  { to: "/", label: "Home", exact: true },
  { to: "/services", label: "Services" },
  { to: "/industries", label: "Industries" },
  { to: "/service-areas", label: "Service Areas" },
  { to: "/blog", label: "Blog" },
  { to: "/about", label: "About" },
  { to: "/contact", label: "Contact" },
];

export function SiteHeader() {
  return (
    <header className="sticky top-0 z-50 border-b border-border bg-background/80 text-foreground backdrop-blur supports-[backdrop-filter]:bg-background/70">
      <div className="mx-auto flex max-w-6xl items-center justify-between gap-4 px-6 py-4">
        <Link to="/" className="flex items-center gap-2.5">
          <span className="inline-flex h-8 w-8 items-center justify-center rounded-full bg-primary text-sm font-semibold text-primary-foreground">
            LT
          </span>
          <span className="font-display text-xl tracking-tight">{BUSINESS.shortName}</span>
        </Link>
        <nav className="hidden items-center gap-1 md:flex">
          {navLinks.map((l) => (
            <Link
              key={l.to}
              to={l.to as string}
              activeOptions={{ exact: l.exact ?? false }}
              activeProps={{ className: "text-foreground" }}
              className="rounded-full px-3 py-2 text-sm text-muted-foreground transition-colors hover:text-foreground"
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <div className="flex items-center gap-3">
          <ThemeToggle />
          <CallNowButton className="hidden sm:inline-flex items-center gap-2 rounded-full bg-primary px-4 py-2 text-sm font-medium text-primary-foreground transition hover:bg-primary/90" />
        </div>
      </div>
      <nav className="flex flex-wrap gap-1 border-t border-border bg-background/90 px-4 py-2 md:hidden">
        {navLinks.map((l) => (
          <Link
            key={l.to}
            to={l.to as string}
            activeOptions={{ exact: l.exact ?? false }}
            activeProps={{ className: "text-foreground" }}
            className="rounded-full px-3 py-1.5 text-xs text-muted-foreground"
          >
            {l.label}
          </Link>
        ))}
      </nav>
    </header>
  );
}